module.exports = __webpack_public_path__ + "img/hero-mobile.c0e89e41.jpg";